import { render, staticRenderFns } from "./ContentEditableDiv.vue?vue&type=template&id=33bfa392&scoped=true"
import script from "./ContentEditableDiv.vue?vue&type=script&lang=js"
export * from "./ContentEditableDiv.vue?vue&type=script&lang=js"
import style0 from "./ContentEditableDiv.vue?vue&type=style&index=0&id=33bfa392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bfa392",
  null
  
)

export default component.exports